import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../common/PageLayout';
import '../css/Step1.css';
import { handleImportProcess } from '../utils/fileHandlers/importHandler';
import { ImportJPServerDataCsv } from '../utils/api/productApi';


const ImportJPServerCsv = () => {
    const [error, setError] = useState(null);
    const [statusMessage, setStatusMessage] = useState('waiting...');
    const [isImporting, setIsImporting] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [animatedText, setAnimatedText] = useState('Select CSV Files');
    const fileList = [
        'jp_server_category.csv',
        'jp_server_multiImage.csv',
        'jp_server_option.csv',
        'jp_server_option_id.csv',
        'jp_server_product.csv',
        'jp_server_virtual_category_display.csv',
        'jp_server_product_sequence.csv'
    ];
    useEffect(() => {
        // 기존 텍스트 애니메이션 로직 유지
        if (isImporting) {
            let currentIndex = 0;
            const fullText = 'Send CSV to DB Server...';
            const timer = setInterval(() => {
                setAnimatedText(fullText.slice(0, currentIndex + 1));
                currentIndex++;
                if (currentIndex === fullText.length) currentIndex = 0;
            }, 150);
            return () => clearInterval(timer);
        }
    }, [isImporting]);

    const handleSubmit = async (formData) => {  // formData를 직접 받음
        setError("");
        setIsImporting(true);
        setStatusMessage('Uploading...');
        try {
            // FormData 내용 확인
            console.log('Received FormData entries:');
            for (let pair of formData.entries()) {
                console.log('FormData entry:', pair[0], pair[1]);
            }
            console.log('ImportJPServerDataCsv start');
            const result = await handleImportProcess(() => ImportJPServerDataCsv(formData), 'All CSV Files');

            if (!result.success) {
                setStatusMessage(`Failed to upload files: ${result.message}`);
                return;
            }

            setStatusMessage("All files uploaded successfully.");
            setIsFinished(true);
        } catch (error) {
            console.error('Error:', error);
            setError('Error occurred during upload process.');
            setStatusMessage('Upload failed.');
        } finally {
            setIsImporting(false);
        }
    };
    const validateFile = (file) => {
        const validTypes = [
            "text/csv",
            "application/csv",
            "application/x-csv",
            "text/x-csv",
            "text/comma-separated-values"
        ];
        return validTypes.includes(file.type);
    };

    return (
        <PageLayout
            title="Insert JP Server CSV to DB"
            isFileUpload={true}
            submitButtonText="Upload All CSV Files"
            fileUploadButtonText="Choose CSV Files"
            description={
                <div className="file-list-container">
                    <p className={`animated-text ${isImporting ? 'importing' : ''}`}>
                        {isImporting ? animatedText : 'Required Files:'}
                    </p>
                    <div className="file-grid">
                        {fileList.map((fileName, index) => (
                            <div key={index} className="file-item-card">
                                <span className="file-icon">📄</span>
                                <span className="file-name">{fileName}</span>
                            </div>
                        ))}
                    </div>
                </div>
            }
            onSubmit={handleSubmit}
            validateFile={validateFile}
            error={error}
            statusMessage={statusMessage}
            multiple={true}
            acceptTypes=".csv"
        >
            {isFinished && !isImporting && (
                <Link to="/bulk-db-conversion" className="next-button">
                    Next
                </Link>
            )}
        </PageLayout>
    );
};

export default ImportJPServerCsv;